export default [
    {
        idName: 'male-female-row',
        images: [
            {
                text: 'Male',
                offFile: require('@/assets/images/body/male_full.png'),
                onFile: require('@/assets/images/body/male_full.png'),
                hoverFile: require('@/assets/images/body/male_full.png'),
                xPos: 0,
                yPos: 0
            },
            {
                text: 'Female',
                offFile: require('@/assets/images/body/female_full.png'),
                onFile: require('@/assets/images/body/female_full.png'),
                hoverFile: require('@/assets/images/body/female_full.png'),
                xPos: 0,
                yPos: 0
            }
        ]
    },
    {
        idName: 'male-row',
        images: [
            {
                text: 'Front-Head',
                offFile: require('@/assets/images/body/male/front/head-shoulders.png'),
                onFile: require('@/assets/images/body/male/front/head-shoulders_active.png'),
                hoverFile: require('@/assets/images/body/male/front/head-shoulders_hover.png'),
                xPos: 45,
                yPos: 0,
                zIndex: 0
            },
            {
                text: 'Front-Right-Arm',
                offFile: require('@/assets/images/body/male/front/right-arm.png'),
                onFile: require('@/assets/images/body/male/front/right-arm_active.png'),
                hoverFile: require('@/assets/images/body/male/front/right-arm_hover.png'),
                xPos: 17,
                yPos: 83,
                zIndex: 3
            },
            {
                text: 'Front-Torso',
                offFile: require('@/assets/images/body/male/front/chest.png'),
                onFile: require('@/assets/images/body/male/front/chest_active.png'),
                hoverFile: require('@/assets/images/body/male/front/chest_hover.png'),
                xPos: 46,
                yPos: 83,
                zIndex: 0
            },
            {
                text: 'Front-Left-Arm',
                offFile: require('@/assets/images/body/male/front/left-arm.png'),
                onFile: require('@/assets/images/body/male/front/left-arm_active.png'),
                hoverFile: require('@/assets/images/body/male/front/left-arm_hover.png'),
                xPos: 127,
                yPos: 83,
                zIndex: 3
            },
            {
                text: 'Front-Pelvis',
                offFile: require('@/assets/images/body/male/front/pelvis.png'),
                onFile: require('@/assets/images/body/male/front/pelvis_active.png'),
                hoverFile: require('@/assets/images/body/male/front/pelvis_hover.png'),
                xPos: 55,
                yPos: 165,
                zIndex: 0
            },
            {
                text: 'Front-Right-Leg',
                offFile: require('@/assets/images/body/male/front/right-leg.png'),
                onFile: require('@/assets/images/body/male/front/right-leg_active.png'),
                hoverFile: require('@/assets/images/body/male/front/right-leg_hover.png'),
                xPos: 36,
                yPos: 209,
                zIndex: 2
            },
            {
                text: 'Front-Left-Leg',
                offFile: require('@/assets/images/body/male/front/left-leg.png'),
                onFile: require('@/assets/images/body/male/front/left-leg_active.png'),
                hoverFile: require('@/assets/images/body/male/front/left-leg_hover.png'),
                xPos: 95,
                yPos: 209,
                zIndex: 2
            },
            {
                text: 'Back-Head',
                offFile: require('@/assets/images/body/male/back/head-shoulders.png'),
                onFile: require('@/assets/images/body/male/back/head-shoulders_active.png'),
                hoverFile: require('@/assets/images/body/male/back/head-shoulders_hover.png'),
                xPos: 45,
                yPos: 2,
                zIndex: 0
            },
            {
                text: 'Back-Right-Arm',
                offFile: require('@/assets/images/body/male/back/right-arm.png'),
                onFile: require('@/assets/images/body/male/back/right-arm_active.png'),
                hoverFile: require('@/assets/images/body/male/back/right-arm_hover.png'),
                xPos: 21,
                yPos: 83,
                zIndex: 3
            },
            {
                text: 'Back-Torso',
                offFile: require('@/assets/images/body/male/back/chest.png'),
                onFile: require('@/assets/images/body/male/back/chest_active.png'),
                hoverFile: require('@/assets/images/body/male/back/chest_hover.png'),
                xPos: 46,
                yPos: 83,
                zIndex: 0
            },
            {
                text: 'Back-Left-Arm',
                offFile: require('@/assets/images/body/male/back/left-arm.png'),
                onFile: require('@/assets/images/body/male/back/left-arm_active.png'),
                hoverFile: require('@/assets/images/body/male/back/left-arm_hover.png'),
                xPos: 122,
                yPos: 83,
                zIndex: 3
            },
            {
                text: 'Back-Pelvis',
                offFile: require('@/assets/images/body/male/back/pelvis.png'),
                onFile: require('@/assets/images/body/male/back/pelvis_active.png'),
                hoverFile: require('@/assets/images/body/male/back/pelvis_hover.png'),
                xPos: 56,
                yPos: 165,
                zIndex: 0
            },
            {
                text: 'Back-Right-Leg',
                offFile: require('@/assets/images/body/male/back/right-leg.png'),
                onFile: require('@/assets/images/body/male/back/right-leg_active.png'),
                hoverFile: require('@/assets/images/body/male/back/right-leg_hover.png'),
                xPos: 36,
                yPos: 209,
                zIndex: 2
            },
            {
                text: 'Back-Left-Leg',
                offFile: require('@/assets/images/body/male/back/left-leg.png'),
                onFile: require('@/assets/images/body/male/back/left-leg_active.png'),
                hoverFile: require('@/assets/images/body/male/back/left-leg_hover.png'),
                xPos: 92,
                yPos: 209,
                zIndex: 2
            }
        ]
    },
    {
        idName: 'female-row',
        images: [
            {
                text: 'Front-Head',
                offFile: require('@/assets/images/body/female/front/head-shoulders.png'),
                onFile: require('@/assets/images/body/female/front/head-shoulders_active.png'),
                hoverFile: require('@/assets/images/body/female/front/head-shoulders_hover.png'),
                xPos: 45,
                yPos: 6,
                zIndex: 0
            },
            {
                text: 'Front-Right-Arm',
                offFile: require('@/assets/images/body/female/front/right-arm.png'),
                onFile: require('@/assets/images/body/female/front/right-arm_active.png'),
                hoverFile: require('@/assets/images/body/female/front/right-arm_hover.png'),
                xPos: 12,
                yPos: 83,
                zIndex: 3
            },
            {
                text: 'Front-Torso',
                offFile: require('@/assets/images/body/female/front/chest.png'),
                onFile: require('@/assets/images/body/female/front/chest_active.png'),
                hoverFile: require('@/assets/images/body/female/front/chest_hover.png'),
                xPos: 45,
                yPos: 83,
                zIndex: 0
            },
            {
                text: 'Front-Left-Arm',
                offFile: require('@/assets/images/body/female/front/left-arm.png'),
                onFile: require('@/assets/images/body/female/front/left-arm_active.png'),
                hoverFile: require('@/assets/images/body/female/front/left-arm_hover.png'),
                xPos: 111,
                yPos: 83,
                zIndex: 3
            },
            {
                text: 'Front-Pelvis',
                offFile: require('@/assets/images/body/female/front/pelvis.png'),
                onFile: require('@/assets/images/body/female/front/pelvis_active.png'),
                hoverFile: require('@/assets/images/body/female/front/pelvis_hover.png'),
                xPos: 48,
                yPos: 165,
                zIndex: 0
            },
            {
                text: 'Front-Right-Leg',
                offFile: require('@/assets/images/body/female/front/right-leg.png'),
                onFile: require('@/assets/images/body/female/front/right-leg_active.png'),
                hoverFile: require('@/assets/images/body/female/front/right-leg_hover.png'),
                xPos: 48,
                yPos: 209,
                zIndex: 2
            },
            {
                text: 'Front-Left-Leg',
                offFile: require('@/assets/images/body/female/front/left-leg.png'),
                onFile: require('@/assets/images/body/female/front/left-leg_active.png'),
                hoverFile: require('@/assets/images/body/female/front/left-leg_hover.png'),
                xPos: 84,
                yPos: 209,
                zIndex: 2
            },
            {
                text: 'Back-Head',
                offFile: require('@/assets/images/body/female/back/head-shoulders.png'),
                onFile: require('@/assets/images/body/female/back/head-shoulders_active.png'),
                hoverFile: require('@/assets/images/body/female/back/head-shoulders_hover.png'),
                xPos: 45,
                yPos: 7,
                zIndex: 0
            },
            {
                text: 'Back-Right-Arm',
                offFile: require('@/assets/images/body/female/back/right-arm.png'),
                onFile: require('@/assets/images/body/female/back/right-arm_active.png'),
                hoverFile: require('@/assets/images/body/female/back/right-arm_hover.png'),
                xPos: 12,
                yPos: 83,
                zIndex: 3
            },
            {
                text: 'Back-Torso',
                offFile: require('@/assets/images/body/female/back/chest.png'),
                onFile: require('@/assets/images/body/female/back/chest_active.png'),
                hoverFile: require('@/assets/images/body/female/back/chest_hover.png'),
                xPos: 46,
                yPos: 83,
                zIndex: 0
            },
            {
                text: 'Back-Left-Arm',
                offFile: require('@/assets/images/body/female/back/left-arm.png'),
                onFile: require('@/assets/images/body/female/back/left-arm_active.png'),
                hoverFile: require('@/assets/images/body/female/back/left-arm_hover.png'),
                xPos: 111,
                yPos: 83,
                zIndex: 3
            },
            {
                text: 'Back-Pelvis',
                offFile: require('@/assets/images/body/female/back/pelvis.png'),
                onFile: require('@/assets/images/body/female/back/pelvis_active.png'),
                hoverFile: require('@/assets/images/body/female/back/pelvis_hover.png'),
                xPos: 48,
                yPos: 165,
                zIndex: 0
            },
            {
                text: 'Back-Right-Leg',
                offFile: require('@/assets/images/body/female/back/right-leg.png'),
                onFile: require('@/assets/images/body/female/back/right-leg_active.png'),
                hoverFile: require('@/assets/images/body/female/back/right-leg_hover.png'),
                xPos: 48,
                yPos: 209,
                zIndex: 2
            },
            {
                text: 'Back-Left-Leg',
                offFile: require('@/assets/images/body/female/back/left-leg.png'),
                onFile: require('@/assets/images/body/female/back/left-leg_active.png'),
                hoverFile: require('@/assets/images/body/female/back/left-leg_hover.png'),
                xPos: 84,
                yPos: 209,
                zIndex: 2
            }
        ]
    }
]
